// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#content {
  padding: 20px;
  padding-top: 0;
}

#slider {
  display: none;
}

.initially-hidden {
  display: none;
}

.slick-dots li button::before {
  color: var(--ds-text);
}

.slick-dots li.slick-active button::before {
  color: var(--ds-text);
}

.slick-slide {
  height: unset;
}

.slick-slide img {
  display: initial;
}

/* Address iPhone bug with slick in iFrame, ref. https://github.com/kenwheeler/slick/issues/2834 */
div.slick-slider {
  width: 1px;
  min-width: 100%;
  *width: 100%;
}

.slide {
  min-height: 360px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.slide h1 {
  text-align: center;
  padding-bottom: 10px;
}

.slide-cells {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}

.slide-cell-50 {
  box-sizing: border-box;
  flex-grow: 1;
  width: 50%;
  overflow: hidden;
  padding: 10px 20px;
  min-width: 290px;
  text-align: center
}

.slide-cell-100 {
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
  padding: 10px 20px;
  text-align: center
}

.text-content {
  max-width: 400px;
  margin: auto;
  text-align: center;
}

.image-content {
  margin: auto;
}

.image-content img {
  width: 100%;
  max-width: 363px;
}

img.lazy {
  display: none;
}

@media (max-width: 576px) {
  .image-content img {
    max-width: 242px;
  }

  .slide h1 {
    padding: 0 !important;
  }
}

.button-content {
  text-align: center;
}

.config-box {
  background: var(--ds-background-accent-blue-subtler);
  margin: 15px 0;
  padding: 10px;
}

.pu-button {
  padding: 1px 4px;
  background: var(--ds-background-inverse-subtle);
  border-radius: 5px;
  font-family: Courier, monospace, sans-serif;
  font-size: 0.95em;
}

.no-break {
  white-space: nowrap;
}

.pu-button img {
  height: 12px;
  vertical-align: middle;
}

.m_switch {
  width: 36px;
  height: 20px;
  margin-right: 10px;
}

.check-config {
  display: flex;
  align-items: center;
  min-height: 26px;
}

.selectors-box {
  text-align: left;
}

select.size-constrained {
  width: 150px;
}

select {
  margin-bottom: 4px;
}

select:disabled {
  color: darkgray;
}

.thanks-link {
  display: block;
  font-size: 0.8em;
  margin: 20px;
}

.js-auth-success {
  display: none;
}

img.icon-lock {
  height: 14px;
  opacity: 0.6;
  margin-right: 2px;
}

.m_switch_color.disabled {
  background-color: #9aafa3 !important;
}

img.spinner {
  background-image: url('https://p4tcdn.web.app/spinner.gif');
  background-repeat: no-repeat;
  background-position: 50% 50%;
}

.mt-6 {
  margin-top: 6px;
}

.display-none {
  display: none;
}

.beta-tag {
  font-size: 0.56em;
  text-transform: uppercase;
  display: inline;
  vertical-align: super;
  margin-left: 0.7em;
  font-weight: 600;
  background-color: #ea8523;
  color: white;
  padding: 0.05em 0.2em;
}`, "",{"version":3,"sources":["webpack://./styles/welcomeWizard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA,kGAAkG;AAClG;EACE,UAAU;EACV,eAAe;GACf,WAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB;AACF;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oDAAoD;EACpD,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,kBAAkB;EAClB,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2DAA2D;EAC3D,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB","sourcesContent":["#content {\r\n  padding: 20px;\r\n  padding-top: 0;\r\n}\r\n\r\n#slider {\r\n  display: none;\r\n}\r\n\r\n.initially-hidden {\r\n  display: none;\r\n}\r\n\r\n.slick-dots li button::before {\r\n  color: var(--ds-text);\r\n}\r\n\r\n.slick-dots li.slick-active button::before {\r\n  color: var(--ds-text);\r\n}\r\n\r\n.slick-slide {\r\n  height: unset;\r\n}\r\n\r\n.slick-slide img {\r\n  display: initial;\r\n}\r\n\r\n/* Address iPhone bug with slick in iFrame, ref. https://github.com/kenwheeler/slick/issues/2834 */\r\ndiv.slick-slider {\r\n  width: 1px;\r\n  min-width: 100%;\r\n  *width: 100%;\r\n}\r\n\r\n.slide {\r\n  min-height: 360px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n}\r\n\r\n.slide h1 {\r\n  text-align: center;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.slide-cells {\r\n  display: flex;\r\n  flex-flow: row wrap;\r\n  align-items: center;\r\n}\r\n\r\n.slide-cell-50 {\r\n  box-sizing: border-box;\r\n  flex-grow: 1;\r\n  width: 50%;\r\n  overflow: hidden;\r\n  padding: 10px 20px;\r\n  min-width: 290px;\r\n  text-align: center\r\n}\r\n\r\n.slide-cell-100 {\r\n  box-sizing: border-box;\r\n  width: 100%;\r\n  overflow: hidden;\r\n  padding: 10px 20px;\r\n  text-align: center\r\n}\r\n\r\n.text-content {\r\n  max-width: 400px;\r\n  margin: auto;\r\n  text-align: center;\r\n}\r\n\r\n.image-content {\r\n  margin: auto;\r\n}\r\n\r\n.image-content img {\r\n  width: 100%;\r\n  max-width: 363px;\r\n}\r\n\r\nimg.lazy {\r\n  display: none;\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .image-content img {\r\n    max-width: 242px;\r\n  }\r\n\r\n  .slide h1 {\r\n    padding: 0 !important;\r\n  }\r\n}\r\n\r\n.button-content {\r\n  text-align: center;\r\n}\r\n\r\n.config-box {\r\n  background: var(--ds-background-accent-blue-subtler);\r\n  margin: 15px 0;\r\n  padding: 10px;\r\n}\r\n\r\n.pu-button {\r\n  padding: 1px 4px;\r\n  background: var(--ds-background-inverse-subtle);\r\n  border-radius: 5px;\r\n  font-family: Courier, monospace, sans-serif;\r\n  font-size: 0.95em;\r\n}\r\n\r\n.no-break {\r\n  white-space: nowrap;\r\n}\r\n\r\n.pu-button img {\r\n  height: 12px;\r\n  vertical-align: middle;\r\n}\r\n\r\n.m_switch {\r\n  width: 36px;\r\n  height: 20px;\r\n  margin-right: 10px;\r\n}\r\n\r\n.check-config {\r\n  display: flex;\r\n  align-items: center;\r\n  min-height: 26px;\r\n}\r\n\r\n.selectors-box {\r\n  text-align: left;\r\n}\r\n\r\nselect.size-constrained {\r\n  width: 150px;\r\n}\r\n\r\nselect {\r\n  margin-bottom: 4px;\r\n}\r\n\r\nselect:disabled {\r\n  color: darkgray;\r\n}\r\n\r\n.thanks-link {\r\n  display: block;\r\n  font-size: 0.8em;\r\n  margin: 20px;\r\n}\r\n\r\n.js-auth-success {\r\n  display: none;\r\n}\r\n\r\nimg.icon-lock {\r\n  height: 14px;\r\n  opacity: 0.6;\r\n  margin-right: 2px;\r\n}\r\n\r\n.m_switch_color.disabled {\r\n  background-color: #9aafa3 !important;\r\n}\r\n\r\nimg.spinner {\r\n  background-image: url('https://p4tcdn.web.app/spinner.gif');\r\n  background-repeat: no-repeat;\r\n  background-position: 50% 50%;\r\n}\r\n\r\n.mt-6 {\r\n  margin-top: 6px;\r\n}\r\n\r\n.display-none {\r\n  display: none;\r\n}\r\n\r\n.beta-tag {\r\n  font-size: 0.56em;\r\n  text-transform: uppercase;\r\n  display: inline;\r\n  vertical-align: super;\r\n  margin-left: 0.7em;\r\n  font-weight: 600;\r\n  background-color: #ea8523;\r\n  color: white;\r\n  padding: 0.05em 0.2em;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
